<!-- SwipFx Home Page (Static HTML only) -->
<!-- Requires Bootstrap 5 CSS + Bootstrap Icons (optional) -->
<div class="min-vh-100 bg-light">

    <!-- TOP NAV -->
    <nav class="navbar navbar-expand-lg bg-white border-bottom">
        <div class="container">
            <a class="navbar-brand fw-bold" [routerLink]="['/']">SwipFx</a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#topNav">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="topNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item"><a class="nav-link" [routerLink]="['/markets']">Markets</a></li>
                    <li class="nav-item"><a class="nav-link" [routerLink]="['/orders']">Orders</a></li>
                    <li class="nav-item"><a class="nav-link" href="#">Wallets</a></li>
                    <li class="nav-item"><a class="nav-link" [routerLink]="['/support']">Support</a></li>
                    <app-admin-dropdown></app-admin-dropdown>
                </ul>
                

                <!-- RIGHT SIDE NAV -->
                <div class="ms-auto d-flex align-items-center">

                    <!-- IF NOT LOGGED IN -->
                    <ng-container *ngIf="!loggedIn else loggedInBlock">
                        <div class="d-flex gap-2">
                            <a class="btn btn-outline-secondary btn-sm" [routerLink]="['/auth', 'login']">
                                Sign in
                            </a>
                            <a class="btn btn-primary btn-sm" [routerLink]="['/auth', 'register']">
                                Create account
                            </a>
                        </div>
                    </ng-container>

                    <!-- IF LOGGED IN -->
                    <ng-template #loggedInBlock>
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle d-flex align-items-center gap-2" href="#"
                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">

                                    <span class="rounded-circle bg-primary bg-opacity-10
                            d-inline-flex align-items-center justify-content-center" style="width:32px;height:32px;">
                                        <span class="fw-semibold text-primary">{{ initials }}</span>
                                    </span>

                                    <span class="d-none d-lg-inline">{{ displayName }}</span>
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0">
                                    <li>
                                        <a class="dropdown-item" [routerLink]="['/account']">
                                            Profile
                                        </a>
                                    </li>

                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>

                                    <li>
                                        <a class="dropdown-item text-danger" href="javascript:void(0)"
                                            (click)="logout()">
                                            Logout
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </ng-template>

                </div>
            </div>
        </div>
    </nav>

    <!-- HERO -->
    <header class="bg-white border-bottom">
        <div class="container py-5">
            <div class="row align-items-center g-4">
                <div class="col-12 col-lg-7">
                    <span class="badge text-bg-primary-subtle border border-primary-subtle text-primary mb-3">
                        Fast deposits • Instant matching • Secure wallets
                    </span>
                    <h1 class="display-6 fw-bold mb-3">
                        Trade FX like a pro — simple, fast, and transparent.
                    </h1>
                    <p class="text-muted mb-4">
                        Create wallets, place orders, and match instantly. Designed for speed, clarity, and peace of
                        mind.
                    </p>

                    <div class="d-flex flex-wrap gap-2">
                        <a href="#" class="btn btn-primary">Start trading</a>
                        <a href="#" class="btn btn-outline-secondary">View markets</a>
                    </div>

                    <div class="d-flex flex-wrap gap-3 mt-4 small text-muted">
                        <div class="d-flex align-items-center gap-2">
                            <span
                                class="badge text-bg-success-subtle border border-success-subtle text-success">99.9%</span>
                            Uptime target
                        </div>
                        <div class="d-flex align-items-center gap-2">
                            <span class="badge text-bg-info-subtle border border-info-subtle text-info">0</span>
                            Hidden fees
                        </div>
                        <div class="d-flex align-items-center gap-2">
                            <span
                                class="badge text-bg-warning-subtle border border-warning-subtle text-warning">24/7</span>
                            Monitoring
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-5">
                    <!-- Shared order entry -->
                    <app-order-entry
                        title="Create Order"
                        [currencies]="currencies"
                        [fee]="fee"
                        [loading]="loading"
                        [enableInstantQuotes]="loggedIn"
                        (pairChanged)="onOrderPairChanged($event)">
                    </app-order-entry>
                </div>
            </div>
        </div>
    </header>

    <!-- MAIN -->
    <main class="container py-4">

        <!-- MARKET SNAPSHOT -->
        <div class="row g-3 mb-4">
            <div class="col-12 col-md-6 col-lg-3" *ngFor="let snap of limitedSnapshot">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-3">
                        <div class="d-flex justify-content-between align-items-start">
                            <div>
                                <div class="fw-bold">{{snap.pair}}</div>
                                <div class="text-muted small">{{snap.tag}}</div>
                            </div>
                            <span
                                [class]="getOrderPlusMinusStatus(snap.percentChange)">{{snap.percentChange + "%"}}</span>
                        </div>
                        <div class="mt-3 d-flex justify-content-between">
                            <div>
                                <div class="text-muted small">Bid</div>
                                <div class="fw-semibold">{{snap.bid}}</div>
                            </div>
                            <div class="text-end">
                                <div class="text-muted small">Ask</div>
                                <div class="fw-semibold">{{snap.ask}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ORDER BOOK + RECENT TRADES -->
        <div class="row g-3 mb-4">
            <!-- BUY ORDER BOOK -->
            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-0">
                        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
                            <div>
                                <div class="fw-bold">Buy Orders</div>
                                <div class="text-muted small">{{ (selectedOrderPair?.fromCurrency || '—') + '/' + (selectedOrderPair?.toCurrency || '—') }}</div>
                            </div>
                            <span
                                class="badge text-bg-success-subtle border border-success-subtle text-success">Bid</span>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-sm align-middle mb-0" *ngIf="buy.length > 0">
                                <thead class="table-light">
                                    <tr class="small text-muted">
                                        <th>Rate</th>
                                        <th class="text-end">Amount</th>
                                        <th class="text-end">Total</th>
                                        <th class="text-end">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let b of buy">
                                        <td class="fw-semibold">{{ b.rate | smartAmount }}</td>
                                        <td class="text-end">{{ b.remainingAmount | smartAmount:b.fromCurrency.symbol }}</td>
                                        <td class="text-end">{{ (b.rate * b.remainingAmount) | smartAmount:b.toCurrency.symbol }}</td>
                                        <td class="text-end"><button class="btn btn-outline-success btn-sm px-2 py-1" (click)="takeOrder(b)" type="button" role="tab">Sell</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div *ngIf="buy.length === 0" class="p-3 border-top small text-muted">
                            No Buy Orders Pending.
                        </div>

                        <div *ngIf="buy.length > 0" class="p-3 border-top small text-muted">
                            Order status change rapidly, data refreshed at {{ currentTime | date:'medium' }}..
                        </div>
                    </div>
                </div>
            </div>

            <!-- SELL ORDER BOOK -->
            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-0">
                        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
                            <div>
                                <div class="fw-bold">Sell Orders</div>
                                <div class="text-muted small">{{ (selectedOrderPair?.toCurrency || '—') + '/' + (selectedOrderPair?.fromCurrency || '—') }}</div>
                            </div>
                            <span class="badge text-bg-danger-subtle border border-danger-subtle text-danger">Ask</span>
                        </div>

                        <div class="table-responsive" *ngIf="sell.length > 0">
                            <table class="table table-sm align-middle mb-0">
                                <thead class="table-light">
                                    <tr class="small text-muted">
                                        <th>Rate</th>
                                        <th class="text-end">Amount</th>
                                        <th class="text-end">Total</th>
                                        <th class="text-end">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let s of sell">
                                        <td class="fw-semibold">{{ s.rate | smartAmount }}</td>
                                        <td class="text-end">{{ s.remainingAmount | smartAmount:s.fromCurrency.symbol }}</td>
                                        <td class="text-end">{{ (s.rate * s.remainingAmount) | smartAmount:s.toCurrency.symbol }}</td>
                                        <td class="text-end"><button class="btn btn-outline-danger btn-sm px-2 py-1" (click)="takeOrder(s)" type="button" role="tab">Buy</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div *ngIf="sell.length === 0" class="p-3 border-top small text-muted">
                            No Sell Orders Pending.
                        </div>

                        <div *ngIf="sell.length > 0" class="p-3 border-top small text-muted">
                            Order status change rapidly, data refreshed at {{ currentTime | date:'medium' }}..
                        </div>
                    </div>
                </div>
            </div>

            <!-- RECENT TRADES -->
            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-0">
                        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
                            <div>
                                <div class="fw-bold">Recent Trades</div>
                                <div class="text-muted small">Latest matched orders</div>
                            </div>
                            <button class="btn btn-outline-secondary btn-sm">View all</button>
                        </div>

                        <div class="list-group list-group-flush">
                            <div class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let t of recent">
                                <div>
                                    <div class="fw-semibold">{{t.fromCurrency.code}}/{{t.toCurrency.code}}</div>
                                    <div class="text-muted small">{{t.createdAt | date:'medium'}}</div>
                                    <div class="text-muted small"><button class="btn btn-outline-success btn-sm px-2 py-1" (click)="takeOrder(t)" type="button" role="tab">Buy</button></div>
                                </div>
                                <div class="text-end">
                                    <div class="fw-bold">{{ t.remainingAmount | smartAmount:t.fromCurrency.symbol }}</div>
                                    <div class="text-muted small">Rate {{ t.rate | smartAmount:t.toCurrency.symbol }}/{{t.toCurrency.code}}</div>
                                    <div class="text-muted small"><button class="btn btn-outline-danger btn-sm px-2 py-1" (click)="takeOrder(t)" type="button" role="tab">Sell</button></div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="recent.length === 0" class="p-3 border-top small text-muted">
                            No Recent Trade.
                        </div>

                        <div *ngIf="recent.length > 0" class="p-3 border-top small text-muted">
                            Order status change rapidly, data refreshed at {{ currentTime | date:'medium' }}..
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FEATURES / TRUST -->
        <div class="row g-3 mb-4">
            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-4">
                        <div class="fw-bold mb-1">Secure Wallets</div>
                        <div class="text-muted small mb-3">
                            Separate balances by currency. Track holds, ledger entries, and settlements clearly.
                        </div>
                        <ul class="small text-muted mb-0">
                            <li>Multi-currency wallets</li>
                            <li>Available vs. current balance</li>
                            <li>Audit-friendly ledger</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-4">
                        <div class="fw-bold mb-1">Fast Matching</div>
                        <div class="text-muted small mb-3">
                            Place limit orders and get matched quickly in the order book.
                        </div>
                        <ul class="small text-muted mb-0">
                            <li>Live order book</li>
                            <li>Partial fills supported</li>
                            <li>Clear settlement status</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-body p-4">
                        <div class="fw-bold mb-1">Compliance Ready</div>
                        <div class="text-muted small mb-3">
                            KYC-aware flows and sensible defaults to support growth.
                        </div>
                        <ul class="small text-muted mb-0">
                            <li>Tiered verification</li>
                            <li>Limits per currency</li>
                            <li>Audit logs</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- CTA -->
        <div class="card shadow-sm border-0">
            <div class="card-body p-4 d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div>
                    <div class="fw-bold fs-5">Ready to trade?</div>
                    <div class="text-muted">Create an account, fund your wallet, and place your first order.</div>
                </div>
                <div class="d-flex gap-2">
                    <a href="#" class="btn btn-primary" [routerLink]="['/auth', 'register']">Create account</a>
                    <a href="#" class="btn btn-outline-secondary" [routerLink]="['/auth', 'login']">Sign in</a>
                </div>
            </div>
        </div>

        
        <app-footer></app-footer>
    </main>
</div>